export default __webpack_public_path__ + "static/media/billreynolds_hero.d3f35878.jpg";